import script from "./InquireList.vue?vue&type=script&setup=true&name=InquireList&lang=js"
export * from "./InquireList.vue?vue&type=script&setup=true&name=InquireList&lang=js"

const __exports__ = script;

export default __exports__